__turbopack_context__.v({
  "backdrop": "SideSheet-module__BzoJDq__backdrop",
  "body": "SideSheet-module__BzoJDq__body",
  "close": "SideSheet-module__BzoJDq__close",
  "content": "SideSheet-module__BzoJDq__content",
  "description": "SideSheet-module__BzoJDq__description",
  "footer": "SideSheet-module__BzoJDq__footer",
  "header": "SideSheet-module__BzoJDq__header",
  "size-full": "SideSheet-module__BzoJDq__size-full",
  "size-lg": "SideSheet-module__BzoJDq__size-lg",
  "size-md": "SideSheet-module__BzoJDq__size-md",
  "size-sm": "SideSheet-module__BzoJDq__size-sm",
  "size-xl": "SideSheet-module__BzoJDq__size-xl",
  "title": "SideSheet-module__BzoJDq__title",
});
